// import React, { useState, useEffect } from "react";
// import * as XLSX from "xlsx";
// import Swal from 'sweetalert2';
// import '../../../assets/css/Sidebar.css';
// import API from '../../../utils/axiosInstance';

// const AllStaff = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [staffs, setStaffs] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showPopup, setShowPopup] = useState(false);
//   const [formData, setFormData] = useState({
//     id: null,
//     fullName: "",
//     gender: "",
//     email: "",
//     phoneNumber: "",
//     password: "",
//     roleName: "",
//     date: "",
//     address: "",
//     salary: "",
//     shift: "",
//   });

//   const itemsPerPage = 10;

//   const fetchStaffs = () => {
//     API.get('/v1/users')
//       .then((response) => {
//         const formattedData = response.data.map((user) => ({
//           id: user.id,
//           fullName: user.fullName,
//           gender: user.gender || "-",
//           designation: user.roles?.[0]?.name || "-",
//           phoneNumber: user.phoneNumber,
//           email: user.email,
//           password: user.password || "-",
//           date: user.date || "-",
//           address: user.address || "-",
//           salary: user.salary || "-",
//           shift: user.shift || "-"
//         }));
//         setStaffs(formattedData);
//       })
//       .catch((error) => console.error("Error fetching staff data:", error));
//   };

//   useEffect(() => {
//     fetchStaffs();

//     API.get('/v1/roles')
//       .then((res) => setRoles(res.data))
//       .catch((err) => console.error("Error fetching roles:", err));
//   }, []);

//   const filteredStaffs = staffs.filter((staff) => staff.fullName?.toLowerCase().includes(searchTerm.toLowerCase()));
//   const totalPages = Math.ceil(filteredStaffs.length / itemsPerPage);
//   const paginatedStaffs = filteredStaffs.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   const handleDelete = (id) => {
//     setStaffs(staffs.filter((staff) => staff.id !== id));
//   };

//   const handleDownload = () => {
//     const ws = XLSX.utils.json_to_sheet(staffs);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Staff Data");
//     XLSX.writeFile(wb, "staff_data.xlsx");
//   };

//   const handleAddEditStaff = () => {
//     const payload = {
//       email: formData.email,
//       password: formData.password,
//       fullName: formData.fullName,
//       phoneNumber: formData.phoneNumber,
//       roles: [{ name: formData.roleName }],
//     };
  
//     const request = formData.id
//       ? API.patch(`/v1/users/${formData.id}`, payload) // Update mode
//       : API.post('/v1/users', payload);              // Add mode
  
//     request
//       .then(() => {
//         Swal.fire({
//           icon: 'success',
//           title: formData.id ? 'Staff updated successfully' : 'Staff added successfully',
//           showConfirmButton: false,
//           timer: 1500
//         });
  
//         setShowPopup(false);
//         setFormData({
//           id: null,
//           fullName: "",
//           gender: "",
//           email: "",
//           phoneNumber: "",
//           password: "",
//           roleName: "",
//           date: "",
//           address: "",
//           salary: "",
//           shift: "",
//         });
  
//         fetchStaffs(); // Refresh staff list
//       })
//       .catch((error) => {
//         const errorMessage = error.response?.data?.message || "Something went wrong";
//         Swal.fire({
//           icon: 'error',
//           title: 'Error',
//           text: errorMessage,
//         });
//       });
//   };
  

//   return (
//     <div className="container w-100 mw-100">
//     <div className="bg-white">
//       <div className="staff-container">
//         <h4>style={{ color: "black" }}>Staffs</h4>
//         <input
//           type="text"
//           placeholder="Search..."
//           className="search-input"
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <button onClick={() => setShowPopup(true)} className="add-btn">
//           <b>Add Staff</b>
//         </button>
//         <button onClick={handleDownload} className="download-btn">
//           <b>Download Excel</b>
//         </button>

//         <div className="container py-4 w-100 mw-100" style={{overflowX:"scroll"}}>
//           <div className="table-responsive">
//           <table className=" table table-bordered">
//             <thead className="bg-black text-white">
//               <tr >
//                 <th>Name</th>
//                 <th>Gender</th>
//                 <th>Designation</th>
//                 <th>Mobile</th>
//                 <th>Email</th>
//                 <th>Password</th>
//                 <th>Date of Joining</th>
//                 <th>Address</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedStaffs.map((staff) => (
//                 <tr key={staff.id}>
//                   <td>{staff.fullName}</td>
//                   <td><span className={`badge ${staff.gender} text-black`}>{staff.gender}</span></td>
//                   <td>{staff.designation}</td>
//                   <td>{staff.phoneNumber}</td>
//                   <td>{staff.email}</td>
//                   <td>{staff.password}</td>
//                   <td>{staff.date}</td>
//                   <td>{staff.address}</td>
//                   <td>
//                     <button className="edit-btn" onClick={() => { setShowPopup(true); setFormData(staff); }}>✏️</button>
//                     <button className="delete-btn" onClick={() => handleDelete(staff.id)}>🗑</button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <div className="pagination">
//             <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Prev</button>
//             <span>Page {currentPage} of {totalPages}</span>
//             <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
//           </div>
//           </div>
//         </div>

//         {showPopup && (
//           <div className="popup">
//             <div className="popup-content">
//               <h3>{formData.id ? "Edit" : "Add"} Staff</h3>
//               <input type="text" placeholder="Full Name" value={formData.fullName} onChange={(e) => setFormData({ ...formData, fullName: e.target.value })} />
//               <input type="text" placeholder="Gender" value={formData.gender} onChange={(e) => setFormData({ ...formData, gender: e.target.value })} />
//               <input type="text" placeholder="Phone" value={formData.phoneNumber} onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })} />
//               <input type="email" placeholder="Email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
//               <input type="password" placeholder="Password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} />
//               <select className="form-control" value={formData.roleName} onChange={(e) => setFormData({ ...formData, roleName: e.target.value })}>
//                 <option value="">Select Role</option>
//                 {roles.map((role) => (
//                   <option key={role.id} value={role.name}>{role.name}</option>
//                 ))}
//               </select>
//               <button onClick={handleAddEditStaff}>{formData.id ? "Update" : "Add"}</button>
//               <button onClick={() => setShowPopup(false)}>Cancel</button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//     </div>
//   );
// };

// export default AllStaff;





import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
//import "./AllStaff.css"; // Dedicated CSS file
import API from "../../../utils/axiosInstance";
import { API_PATH } from "../../../Constant/constants";

const AllStaff = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [staffs, setStaffs] = useState([]);
  const [roles, setRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    fullName: "",
    gender: "",
    email: "",
    phoneNumber: "",
    password: "",
    roleName: "",
    date: "",
    address: "",
    salary: "",
    shift: "",
  });
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 10;

  // Fetch all users
  const fetchStaffs = async () => {
    try {
      setLoading(true);
      const response = await API.get(`${API_PATH}/users`);
      const formattedData = response.data.map((user) => ({
        id: user.id,
        fullName: user.fullName || "-",
        gender: user.gender || "-",
        designation: user.roles?.[0]?.name || "-",
        phoneNumber: user.phoneNumber || "-",
        email: user.email || "-",
        date: user.date || "-",
        address: user.address || "-",
        salary: user.salary || "-",
        shift: user.shift || "-",
      }));
      setStaffs(formattedData);
    } catch (error) {
      console.error("Error fetching staff data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to fetch staff data.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetch user by ID for editing
  const fetchUserById = async (userId) => {
    try {
      setLoading(true);
      const response = await API.get(`${API_PATH}/users/${userId}`);
      const user = response.data;
      setFormData({
        id: user.id,
        fullName: user.fullName || "",
        gender: user.gender || "",
        email: user.email || "",
        phoneNumber: user.phoneNumber || "",
        password: "", // Do not prefill password
        roleName: user.roles?.[0]?.name || "",
        date: user.date || "",
        address: user.address || "",
        salary: user.salary || "",
        shift: user.shift || "",
      });
      setShowPopup(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Failed to fetch user data.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetch roles
  useEffect(() => {
    fetchStaffs();
    API.get(`${API_PATH}/roles`)
      .then((res) => setRoles(res.data))
      .catch((err) => {
        console.error("Error fetching roles:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response?.data?.message || "Failed to fetch roles.",
        });
      });
  }, []);

  // Filter and paginate staff data
  const filteredStaffs = staffs.filter((staff) =>
    staff.fullName?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const totalPages = Math.ceil(filteredStaffs.length / itemsPerPage);
  const paginatedStaffs = filteredStaffs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Validate form data
  const validateForm = () => {
    if (!formData.fullName) return "Full Name is required";
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      return "Valid email is required";
    if (!formData.phoneNumber || !/^\d{10}$/.test(formData.phoneNumber))
      return "Valid 10-digit phone number is required";
    if (!formData.id && !formData.password) return "Password is required for new staff";
    if (!formData.roleName) return "Role is required";
    return null;
  };

  // Handle add or edit staff
  const handleAddEditStaff = async () => {
    const error = validateForm();
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: error,
      });
      return;
    }

    // Prepare payload, excluding password if not provided (for PATCH)
    const payload = {
      fullName: formData.fullName,
      email: formData.email,
      phoneNumber: formData.phoneNumber,
      gender: formData.gender || undefined,
      roles: formData.roleName ? [{ name: formData.roleName }] : undefined,
      date: formData.date || undefined,
      address: formData.address || undefined,
      salary: formData.salary || undefined,
      shift: formData.shift || undefined,
    };

    // Include password only for POST or if provided for PATCH
    if (!formData.id || (formData.id && formData.password)) {
      payload.password = formData.password;
    }

    try {
      setLoading(true);
      if (formData.id) {
        await API.patch(`${API_PATH}/users/${formData.id}`, payload);
        Swal.fire({
          icon: "success",
          title: "Staff updated successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        await API.post(`${API_PATH}/users`, payload);
        Swal.fire({
          icon: "success",
          title: "Staff added successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      }
      setShowPopup(false);
      setFormData({
        id: null,
        fullName: "",
        gender: "",
        email: "",
        phoneNumber: "",
        password: "",
        roleName: "",
        date: "",
        address: "",
        salary: "",
        shift: "",
      });
      fetchStaffs();
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Something went wrong";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle delete with confirmation
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        await API.delete(`${API_PATH}/users/${id}`);
        setStaffs(staffs.filter((staff) => staff.id !== id));
        Swal.fire({
          icon: "success",
          title: "Staff deleted successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        console.error("Error deleting staff:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.message || "Failed to delete staff.",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  // Handle Excel download (exclude sensitive data)
  const handleDownload = () => {
    const safeStaffs = staffs.map(({ password, ...staff }) => staff); // Remove password
    const ws = XLSX.utils.json_to_sheet(safeStaffs);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Staff Data");
    XLSX.writeFile(wb, "staff_data.xlsx");
  };

  return (
    <div className="container all-staff-container">
      <div className="bg-white p-4">
        <h4>Staffs</h4>
        <div className="d-flex justify-content-between mb-3">
          <input
            type="text"
            placeholder="Search by name..."
            className="form-control w-50"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            disabled={loading}
          />
          <div>
            <button
              onClick={() => {
                setFormData({
                  id: null,
                  fullName: "",
                  gender: "",
                  email: "",
                  phoneNumber: "",
                  password: "",
                  roleName: "",
                  date: "",
                  address: "",
                  salary: "",
                  shift: "",
                });
                setShowPopup(true);
              }}
              className="btn btn-color me-2"
              disabled={loading}
            >
              Add Staff
            </button>
            <button
              onClick={handleDownload}
              className="btn btn-secondary"
              disabled={loading}
            >
              Download Excel
            </button>
          </div>
        </div>

        {loading ? (
          <div>Loading...</div>
        ) : (
          <div className="table-responsive">
            <table className=" table-bordered">
              <thead className="tableborder">
                <tr>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Designation</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Date of Joining</th>
                  <th>Address</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody >
                {paginatedStaffs.length === 0 ? (
                  <tr className="datahover">
                    <td colSpan="8" className="text-center">
                      No staff found
                    </td>
                  </tr>
                ) : (
                  paginatedStaffs.map((staff) => (
                    <tr key={staff.id} className="datahover">
                      <td>{staff.fullName}</td>
                      <td>
                        <span className={`badge bg-${staff.gender.toLowerCase()}`}>
                          {staff.gender}
                        </span>
                      </td>
                      <td>{staff.designation}</td>
                      <td>{staff.phoneNumber}</td>
                      <td>{staff.email}</td>
                      <td>{staff.date}</td>
                      <td>{staff.address}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-color me-2"
                          onClick={() => fetchUserById(staff.id)}
                          disabled={loading}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(staff.id)}
                          disabled={loading}
                        >
                          🗑 Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-between align-items-center">
              <button
                className="btn btn-outline-primary"
                disabled={currentPage === 1 || loading}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary"
                disabled={currentPage === totalPages || loading}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        )}

        {showPopup && (
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {formData.id ? "Edit Staff" : "Add Staff"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowPopup(false)}
                    disabled={loading}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Full Name"
                      value={formData.fullName}
                      onChange={(e) =>
                        setFormData({ ...formData, fullName: e.target.value })
                      }
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Gender</label>
                    <select
                      className="form-control"
                      value={formData.gender}
                      onChange={(e) =>
                        setFormData({ ...formData, gender: e.target.value })
                      }
                      disabled={loading}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone"
                      value={formData.phoneNumber}
                      onChange={(e) =>
                        setFormData({ ...formData, phoneNumber: e.target.value })
                      }
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      disabled={loading}
                    />
                  </div>
                  {!formData.id && (
                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        value={formData.password}
                        onChange={(e) =>
                          setFormData({ ...formData, password: e.target.value })
                        }
                        disabled={loading}
                      />
                    </div>
                  )}
                  {formData.id && (
                    <div className="mb-3">
                      <label className="form-label">New Password (optional)</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="New Password"
                        value={formData.password}
                        onChange={(e) =>
                          setFormData({ ...formData, password: e.target.value })
                        }
                        disabled={loading}
                      />
                    </div>
                  )}
                  <div className="mb-3">
                    <label className="form-label">Role</label>
                    <select
                      className="form-control"
                      value={formData.roleName}
                      onChange={(e) =>
                        setFormData({ ...formData, roleName: e.target.value })
                      }
                      disabled={loading}
                    >
                      <option value="">Select Role</option>
                      {roles.map((role) => (
                        <option key={role.id} value={role.name}>
                          {role.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Date of Joining</label>
                    <input
                      type="date"
                      className="form-control"
                      value={formData.date}
                      onChange={(e) =>
                        setFormData({ ...formData, date: e.target.value })
                      }
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Address"
                      value={formData.address}
                      onChange={(e) =>
                        setFormData({ ...formData, address: e.target.value })
                      }
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Salary</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Salary"
                      value={formData.salary}
                      onChange={(e) =>
                        setFormData({ ...formData, salary: e.target.value })
                      }
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Shift</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Shift"
                      value={formData.shift}
                      onChange={(e) =>
                        setFormData({ ...formData, shift: e.target.value })
                      }
                      disabled={loading}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-primary"
                    onClick={handleAddEditStaff}
                    disabled={loading}
                  >
                    {loading
                      ? "Processing..."
                      : formData.id
                      ? "Update"
                      : "Add"}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowPopup(false)}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllStaff;
